export default __webpack_public_path__ + "static/media/25_tag_courtesy-bus.45287bac.svg";